<template>
  <div class="card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing">
    <div class="card-body">
      <ul class="nav nav-tabs bg-white border-0 rounded-0" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active"
            id="support-details-tab"
            data-bs-toggle="tab"
            data-bs-target="#support-details-tab-pane"
            type="button"
            role="tab"
            aria-controls="support-details-tab-pane"
            aria-selected="true"
          >
            <i class="flaticon-book"></i>
            Détails du support
          </button>
        </li>
        <li  v-if="checkPermission('ListQuestionFiltre')" class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100"
            id="payment-method-tab"
            data-bs-toggle="tab"
            data-bs-target="#payment-method-tab-pane"
            type="button"
            role="tab"
            aria-controls="payment-method-tab-pane"
            aria-selected="false"
          >
            <i class="flaticon-atm"></i>
          QCM
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100"
            id="place-order-tab"
            data-bs-toggle="tab"
            data-bs-target="#place-order-tab-pane"
            type="button"
            role="tab"
            aria-controls="place-order-tab-pane"
            aria-selected="false"
          >
            <i class="flaticon-sterile-box"></i>
           Liste des inscrits en ligne
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100"
            id="fourth-tab"
            data-bs-toggle="tab"
            data-bs-target="#fourth-tab-pane"
            type="button"
            role="tab"
            aria-controls="fourth-tab-pane"
            aria-selected="false"
          >
            <i class="flaticon-layers"></i>
            Quatrième onglet
          </button>
        </li>
      </ul>

      <div class="tab-content p-15 p-sm-20 p-md-25 p-lg-30" id="myTabContent">

        <!-- ===== ONGLET 1 : Détails du support ===== -->
        <div
          class="tab-pane fade show active"
          id="support-details-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4">
            <router-link to="/liste-support" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative">Retour</span>
            </router-link>
            <h4 class="mb-0">Détails du support de cours</h4>
          </div>

          <div class="row mb-4">
            <div class="col-md-6">
              <div class="info-card p-3 border rounded bg-light">
                <h6 class="text-primary mb-3">
                  <i class="flaticon-book me-2"></i>Informations générales
                </h6>
                <div class="row mb-2">
                  <div class="col-5"><strong>Titre :</strong></div>
                  <div class="col-7">{{ supportCours?.titre || 'Aucun titre' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Image:</strong></div>
                  <div class="col-7">
                    <img :src="getUrlApiForFilesSupport(supportCours?.urlImage || 'Aucune image')" alt="Image" width="200" height="200">
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Description :</strong></div>
                  <div class="col-7">{{ supportCours?.description || 'Aucune description' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Auteur :</strong></div>
                  <div class="col-7">{{ supportCours?.auteur || 'Aucun Auteur' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Nombre d'heures :</strong></div>
                  <div class="col-7">{{ supportCours?.nombreHeures || 0 }} h</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Nombre de modules :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-success">{{ supportCours?.modules?.length || 0 }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Prérequis :</strong></div>
                  <div class="col-7">{{ supportCours?.prerequis || 'Aucun' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Fichier principal :</strong></div>
                  <div class="col-7">
                    <div v-if="supportCours?.fichier" class="d-flex flex-column gap-2">
                      <div class="file-name-display mb-2">
                        <i class="flaticon-file me-2 text-danger"></i>
                        <small class="text-muted">{{ supportCours.fichier }}</small>
                      </div>
                      <div class="d-flex gap-2">
                        <button @click="viewSupportFile(supportCours.id)" class="btn btn-sm btn-outline-primary">
                          <i class="flaticon-eye me-1"></i>Voir
                        </button>
                        <!-- <button @click="downloadSupportFile(supportCours.id, supportCours.titre)" class="btn btn-sm btn-outline-success">
                          <i class="flaticon-download me-1"></i>Télécharger
                        </button> -->
                      </div>
                    </div>
                    <span v-else class="text-muted">Aucun fichier</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="info-card p-3 border rounded bg-light">
                <h6 class="text-primary mb-3">
                  <i class="flaticon-layers me-2"></i>Filière / Niveau / Matière
                </h6>
                <div class="row mb-2">
                  <div class="col-5"><strong>Filière :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-info">{{ supportCours?.filiereNiveauMatiere?.filiere?.libelle || 'N/A' }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Niveau :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-warning">{{ supportCours?.filiereNiveauMatiere?.niveau?.libelle || 'N/A' }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Matière :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-primary">{{ supportCours?.filiereNiveauMatiere?.matiere?.libelle || 'N/A' }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Date de création :</strong></div>
                  <div class="col-7">{{ formatDate(supportCours?.createdAt) }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vidéos et textes -->
          <div class="row">
            <div class="col">
              <h5 class="text-black fw-bold mt-4">Vidéos et textes du support</h5>
            </div>
            <div class="col text-end">
              <router-link :to="{ name: 'AddSupportCours', params: { id: supportCours?.id } }" class="btn btn-primary mt-3 text-center">
                <i class="fa fa-plus-circle lh-2 me-8 position-relative top-1"></i> Compléter vidéo et support
              </router-link>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-6 mb-3">
              <h5 class="text-primary mb-3 border-bottom pb-2">
                <i class="fa fa-video me-2"></i>Vidéos ({{ videos.length }})
              </h5>
              <div v-if="videos.length > 0">
                <div v-for="(video, index) in videos" :key="video.id" class="border rounded p-3 mb-3 bg-white shadow-sm">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <strong>{{ video.libelle || 'Sans titre' }}</strong>
                      <div class="text-muted small">
                        Type source : <span class="badge bg-secondary">{{ video.type || 'N/A' }}</span>
                      </div>
                    </div>
                    <span class="badge bg-warning text-dark">Vidéo {{ index + 1 }}</span>
                  </div>
                  <p class="mb-1" v-if="video.description"><strong>Description :</strong> {{ video.description }}</p>
                  <div v-if="video.type === 'url' && video.lien" class="mt-2">
                    <strong>URL :</strong>
                    <a :href="video.lien" target="_blank" rel="noopener noreferrer" class="ms-1">{{ video.lien }}</a>
                  </div>
                  <div v-else-if="video.type === 'fichier' && video.lien" class="mt-2">
                    <strong>Fichier :</strong>
                    <span class="text-muted ms-1">{{ video.lien }}</span>
                    <div class="d-flex gap-2 mt-2">
                      <button @click="viewMediaFile(video.id, video.libelle)" class="btn btn-sm btn-outline-primary">
                        <i class="flaticon-eye me-1"></i>Voir
                      </button>
                      <!-- <button @click="downloadMediaFile(video.id, video.libelle)" class="btn btn-sm btn-outline-success">
                        <i class="flaticon-download me-1"></i>Télécharger
                      </button> -->
                    </div>
                  </div>
                  <div v-else class="text-muted mt-1"><small>Aucun lien disponible</small></div>
                </div>
              </div>
              <div v-else class="alert alert-info">
                <i class="flaticon-info me-2"></i>Aucune vidéo ajoutée pour ce support.
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <h5 class="text-primary mb-3 border-bottom pb-2">
                <i class="fa fa-file-alt me-2"></i>Textes ({{ textes.length }})
              </h5>
              <div v-if="textes.length > 0">
                <div v-for="(texte, index) in textes" :key="texte.id" class="border rounded p-3 mb-3 bg-white shadow-sm">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <strong>{{ texte.libelle || 'Sans titre' }}</strong>
                      <div class="text-muted small">
                        Type : <span class="badge bg-info text-dark">{{ texte.type || 'N/A' }}</span>
                      </div>
                    </div>
                    <span class="badge bg-info text-dark">Texte {{ index + 1 }}</span>
                  </div>
                  <div v-if="texte.lien" class="mt-2">
                    <strong>Fichier :</strong>
                    <span class="text-muted ms-1">{{ texte.lien }}</span>
                    <div class="d-flex gap-2 mt-2">
                      <button @click="viewMediaFile(texte.id, texte.libelle)" class="btn btn-sm btn-outline-primary">
                        <i class="flaticon-eye me-1"></i>Voir
                      </button>
                      <!-- <button @click="downloadMediaFile(texte.id, texte.libelle)" class="btn btn-sm btn-outline-success">
                        <i class="flaticon-download me-1"></i>Télécharger
                      </button> -->
                    </div>
                  </div>
                  <div v-else class="text-muted mt-1"><small>Aucun fichier disponible</small></div>
                </div>
              </div>
              <div v-else class="alert alert-info">
                <i class="flaticon-info me-2"></i>Aucun texte ajouté pour ce support.
              </div>
            </div>
          </div>

          <!-- Modules -->
          <div class="row">
            <div class="col-md-12">
              <h5 class="text-primary mb-3 border-bottom pb-2">
                <i class="flaticon-book me-2"></i>Liste des modules ({{ supportCours?.modules?.length || 0 }})
              </h5>
              <div v-if="supportCours?.modules && supportCours.modules.length > 0">
                <div v-for="(module, index) in supportCours.modules" :key="module.id" class="cours-card border rounded p-3 mb-3 shadow-sm bg-white">
                  <div class="cours-header bg-primary text-white p-2 rounded mb-3">
                    <h6 class="mb-0">
                      <i class="flaticon-book me-2"></i>Module {{ index + 1 }} : {{ module.titre }}
                    </h6>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Code</small>
                        <strong>{{ module.code || 'Sans code' }}</strong>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Titre</small>
                        <strong>{{ module.titre || 'Aucun titre' }}</strong>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Description</small>
                        <strong>{{ module.description || 'Aucune description' }}</strong>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Fichier du module</small>
                        <div v-if="module.fichier" class="mt-2">
                          <div class="file-name-display mb-2">
                            <i class="flaticon-file me-1 text-danger"></i>
                            <small class="text-muted">{{ module.fichier }}</small>
                          </div>
                          <div class="d-flex gap-2">
                            <button @click="viewModuleFile(module.id)" class="btn btn-sm btn-outline-primary">
                              <i class="flaticon-eye me-1"></i>Voir
                            </button>
                            <!-- <button @click="downloadModuleFile(module.id, module.titre || module.code)" class="btn btn-sm btn-outline-success">
                              <i class="flaticon-download me-1"></i>Télécharger
                            </button> -->
                          </div>
                        </div>
                        <span v-else class="text-muted">Aucun fichier</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="alert alert-info">
                <i class="flaticon-info me-2"></i>Aucun module trouvé pour ce support de cours.
              </div>
            </div>
          </div>
        </div>

          <!-- ===== ONGLET 2 : AddQuestionQCM ===== -->
        <div class="tab-pane fade" id="payment-method-tab-pane" role="tabpanel" tabindex="0">
           <div v-show="!showAddQuestionForm" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <h5 class="mb-0 text-black fw-bold">Questions du support</h5>
              <button @click="showAddQuestionForm = true" class="btn btn-primary">
                <i class="fa fa-plus-circle me-2"></i> Ajouter une question
              </button>
            </div>
            <div class="card-body p-15 p-sm-20 p-md-25">
              <ListeQuestion :support-id="supportCours?.id" :refresh-trigger="refreshKey"/>
            </div>
          </div>
          <div v-show="showAddQuestionForm">
            <button @click="showAddQuestionForm = false" class="btn btn-secondary mb-3">
              <i class="fa fa-arrow-left me-2"></i> Retour à la liste
            </button>
            <AddQuestionQCM :current-support-id="supportCours?.id" @question-added="refreshQuestions" />
          </div>
        </div>
       <!-- <div class="tab-pane fade" id="payment-method-tab-pane" role="tabpanel" tabindex="0">
         <div class="card-body p-15 p-sm-20 p-md-25">
              <ListeQuestion :support-id="supportCours?.id" />
        </div>
        
          <AddQuestionQCM :current-support-id="supportCours?.id" />
        </div>-->

        <!-- ===== ONGLET 3 : Cours en ligne ===== -->
        <div class="tab-pane fade" id="place-order-tab-pane" role="tabpanel" tabindex="0">
          <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
            
            <div
              class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
            >
              
              <div class="d-flex align-items-center">
                <form class="search-box position-relative" @submit.prevent="rechercher">
                  <input
                    type="text"
                    v-model="searchTerm"
                    @keyup="rechercher"
                    class="form-control shadow-none text-black rounded-0 border-0"
                    placeholder="Rechercher un cours en ligne"
                  />
                  <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                    <i class="flaticon-search-interface-symbol"></i>
                  </button>
                </form>
              </div>
            </div>
            <div class="card-body p-15 p-sm-20 p-md-25">
              <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      >
                        Nom
                      </th>
                     <th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      >
                        Prénom
                      </th>
                     <th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      >
                        Sexe
                      </th>
                      <th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      >
                        Téléphone 1
                      </th>
                     <th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                      >
                        Date de naissance
                      </th>
                      
                     
                      <!--<th
                        scope="col"
                        class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
                      >ACTIONS</th>-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(coursenligne, index) in coursenlignes" :key="coursenligne.id || index">
                       <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ coursenligne.nom }}
                      </td>
                       <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ coursenligne.prenom }}
                      </td>
                       <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ coursenligne.sexe }}
                      </td>
                       <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ coursenligne.email }}
                      </td>
                       <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ coursenligne.telephone1 }}
                      </td>
                      <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ format_Date(coursenligne.dateNaissance) }}
                      </td>
                     
                      <td
                        class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
                      >
                      <!-- <div class="dropdown">
                      <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                              Actions
                              <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                          </span>
                          <ul class="dropdown-menu dropdown-block" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(267px, 305px);" data-popper-placement="bottom-start">
                           
                            
                           
                            <li class="dropdown-item d-flex align-items-center" >
                              <a
                                class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(coursenligne.id,coursenlignes,'coursenlignes',`le cours en ligne ${coursenligne.id}`)">
                                <i class="fa fa-trash-o lh-1 me-8 position-relative top-1" ></i>
                                 Supprimer
                              </a>
                            </li>
                          </ul>
                          </div>-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
              >
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
              </div>
            </div>
            </div>
          </div>
        

        <!-- ===== ONGLET 4 : Quatrième onglet ===== -->
        <div class="tab-pane fade" id="fourth-tab-pane" role="tabpanel" tabindex="0">
          <h5 class="mb-15 mb-md-25 fw-bold text-black">Quatrième onglet</h5>
          <!-- Contenu à définir -->
        </div>

      </div>
    </div>

    <!-- Modal PDF -->
    <div
      v-if="showPdfModal"
      class="modal fade show d-block pdf-modal-overlay"
      tabindex="-1"
      @click.self="closePdfModal"
    >
      <div class="modal-dialog modal-xl modal-dialog-top">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="flaticon-file me-2"></i>{{ currentPdfTitle }}
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="closePdfModal"></button>
          </div>
          <div class="modal-body p-0 pdf-viewer-container">
            <iframe v-if="currentPdfBlob" :src="currentPdfBlob" class="pdf-viewer-iframe" title="Visualiseur PDF"></iframe>
            <div v-else class="d-flex justify-content-center align-items-center" style="height: 80vh;">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Chargement...</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closePdfModal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";
import { error, success, getUrlApiForFiles,getUrlApiForFilesSupport, format_Date, suppression } from "@/utils/utils";
import AddQuestionQCM from "@/components/Question/AddQuestionQCM.vue";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import { CoursEnLigne } from "@/models/CoursEnLigne";
import ListeQuestion from "../Question/ListeQuestion.vue";
import JwtService from "@/services/JwtService.js";



export default defineComponent({
  name: "ViewSupportCours",
  components: { AddQuestionQCM, ListeQuestion, PaginationComponent },
  setup() {
    const route = useRoute();
    const supportCours = ref<any>(null);
    const showPdfModal = ref(false);
    const currentPdfBlob = ref('');
    const currentPdfTitle = ref('');
    const showAddQuestionForm = ref(false);
    const refreshKey = ref(0);

    const getSupportCours = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/supports/${id}`);
        supportCours.value = data.data;
        console.log(" Support de cours chargé:", data.data);
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement du support de cours");
        console.error(" Erreur:", err);
      }
    };

     const privileges = ref<string[]>(JwtService.getPrivilege());
    const checkPermission = (perm: string) => privileges.value.includes(perm);

    const viewSupportFile = async (supportId: number) => {
      try {
        currentPdfTitle.value = 'Support de cours';
        showPdfModal.value = true;
        
        const response = await ApiService.get(`/supports/${supportId}/download`, { 
          responseType: 'blob' 
        });
        
        const blob = new Blob([response.data], { type: 'application/pdf' });
        currentPdfBlob.value = window.URL.createObjectURL(blob);
        
        document.body.style.overflow = 'hidden';
      } catch (err: any) {
        console.error("❌ Erreur visualisation:", err);
        error("Impossible de visualiser le fichier");
        closePdfModal();
      }
    };

    // ✅ Voir le fichier du module dans le modal
    const viewModuleFile = async (moduleId: number) => {
      try {
        currentPdfTitle.value = 'Module';
        showPdfModal.value = true;
        
        const response = await ApiService.get(`/supports/modules/${moduleId}/download`, { 
          responseType: 'blob' 
        });
        
        const blob = new Blob([response.data], { type: 'application/pdf' });
        currentPdfBlob.value = window.URL.createObjectURL(blob);
        
        document.body.style.overflow = 'hidden';
      } catch (err: any) {
        console.error("❌ Erreur visualisation module:", err);
        error("Impossible de visualiser le module");
        closePdfModal();
      }
    };

    const closePdfModal = () => {
      showPdfModal.value = false;
      if (currentPdfBlob.value) {
        window.URL.revokeObjectURL(currentPdfBlob.value);
      }
      currentPdfBlob.value = '';
      currentPdfTitle.value = '';
      document.body.style.overflow = '';
    };

    // ✅ Téléchargement du support
    const downloadSupportFile = async (supportId: number, titre: string) => {
      try {
        const response = await ApiService.get(`/supports/${supportId}/download`, { 
          responseType: 'blob' 
        });
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${titre.replace(/[^a-z0-9]/gi, '_') || 'support'}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        success("Support téléchargé avec succès !");
      } catch (err: any) {
        console.error("❌ Erreur téléchargement:", err);
        error("Fichier non disponible ou erreur de téléchargement");
      }
    };

    // ✅ Téléchargement du module
    const downloadModuleFile = async (moduleId: number, titre: string) => {
      try {
        const response = await ApiService.get(`/supports/modules/${moduleId}/download`, { 
          responseType: 'blob' 
        });
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${titre.replace(/[^a-z0-9]/gi, '_') || 'module'}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        success("Module téléchargé avec succès !");
      } catch (err: any) {
        console.error("❌ Erreur téléchargement module:", err);
        error("Module non disponible");
      }
    };

    const formatDate = (date: string) => {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    const refreshQuestions = () => {
      getSupportCours(route.params.id as string);
  showAddQuestionForm.value = false;
  refreshKey.value += 1;     // ← IMPORTANT

      console.log("✅ Liste des questions rafraîchie");

  // Recharger la liste des questions si nécessaire
  console.log("Question ajoutée avec succès");
};

    // ─── Computed : séparer les médias par typeMedia ──────────────────────
    const videos = computed<any[]>(() => {
      if (!supportCours.value?.medias) return [];
      return supportCours.value.medias.filter(
        (m: any) => m.typeMedia === 'video'   // correspond à TypeMedia.VIDEO = "video"
      );
    });

    const textes = computed<any[]>(() => {
      if (!supportCours.value?.medias) return [];
      return supportCours.value.medias.filter(
        (m: any) => m.typeMedia === 'texte'   // correspond à TypeMedia.TEXTE = "texte"
      );
    });

   

    // ─── Voir/télécharger un média (fichier vidéo ou texte) ───────────────
    const viewMediaFile = async (mediaId: number, titre: string) => {
      try {
        currentPdfTitle.value = titre || 'Média';
        showPdfModal.value = true;
        currentPdfBlob.value = '';   // reset pour afficher le spinner

        const response = await ApiService.get(`/medias/${mediaId}/download`, {
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' });
        currentPdfBlob.value = window.URL.createObjectURL(blob);
        document.body.style.overflow = 'hidden';
      } catch (err: any) {
        error("Impossible de visualiser le fichier");
        closePdfModal();
      }
    };

    const downloadMediaFile = async (mediaId: number, titre: string) => {
      try {
        const response = await ApiService.get(`/medias/${mediaId}/download`, {
          responseType: 'blob'
        });

        const contentType = response.headers['content-type'] || 'application/octet-stream';
        const extension = contentType.includes('pdf') ? '.pdf'
          : contentType.includes('video') ? '.mp4'
          : contentType.includes('word') ? '.docx'
          : '';

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${(titre || 'media').replace(/[^a-z0-9]/gi, '_')}${extension}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        success("Téléchargement démarré !");
      } catch (err: any) {
        error("Fichier non disponible ou erreur de téléchargement");
      }
    };


    onMounted(async () => {
      const id = route.params.id as string;
      if (id) {
        await getSupportCours(id);
        await getInscriptionsEnLigneBySupport(id);
      }
    });

    // ─── Gestion des inscriptions du support de cours ──────────────────────
    const coursenlignes = ref<Array<CoursEnLigne>>([]);
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getInscriptionsEnLigneBySupport(route.params.id as string, page_, limit_, searchTerm.value);
      } catch (error) {
        //
      }
    };

    const rechercher = () => {
      page.value = 1;
      getInscriptionsEnLigneBySupport(route.params.id as string, page.value, limit.value, searchTerm.value);
    };

    const getInscriptionsEnLigneBySupport = async (
      supportId: string | null = null,
      pageNum = 1,
      limi = 10,
      search = ''
    ) => {
      const id = supportId || (supportCours.value ? supportCours.value.id : null);
      if (!id) {
        console.log('[ViewSupport] getInscriptionsEnLigneBySupport appelé sans supportId');
        return;
      }

      console.log('[ViewSupport] getInscriptionsEnLigneBySupport start', {
        supportId: id,
        pageNum,
        limit: limi,
        search
      });

      try {
        const { data } = await ApiService.get(
          `/inscriptionsenlignes/support/${id}?page=${pageNum}&limit=${limi}&mot=${encodeURIComponent(search)}&`
        );
        console.log('[ViewSupport] getInscriptionsEnLigneBySupport response', data);

        const responseBody = data?.data ?? data;
        const pageData = responseBody?.data ?? responseBody;
        const items = Array.isArray(pageData) ? pageData : pageData?.data ?? [];

        coursenlignes.value = items;
        console.log('✅ Tableau inscriptions chargé :', coursenlignes.value);

        totalPages.value = responseBody?.totalPages ?? pageData?.totalPages ?? 0;
        limit.value = responseBody?.limit ?? pageData?.limit ?? limi;
        totalElements.value = responseBody?.totalElements ?? pageData?.totalElements ?? items.length;

        return items;
      } catch (err: any) {
        console.error('[ViewSupport] getInscriptionsEnLigneBySupport erreur', err);
        error(err.response?.data?.message || 'Erreur lors du chargement des inscriptions du support');
      }
    };



    return { 
      supportCours,
      showPdfModal,
       videos,          // ← computed depuis medias[]
      textes, 
      viewMediaFile,
      downloadMediaFile,  
      getInscriptionsEnLigneBySupport, 
      refreshQuestions,    
      refreshKey,  // ← computed depuis medias[]
      currentPdfBlob,
      currentPdfTitle,
      viewSupportFile,
      viewModuleFile,
      closePdfModal,
      downloadSupportFile,
      downloadModuleFile,
      getUrlApiForFiles,
      getUrlApiForFilesSupport,
      formatDate,
      // Cours en ligne
      coursenlignes,
      searchTerm,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      suppression,
      format_Date,
      showAddQuestionForm,
      checkPermission
    };
  },
});
</script>

<style scoped>
.pdf-modal-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.pdf-viewer-container {
  height: 80vh;
}

.pdf-viewer-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.modal-dialog-top {
  margin-top: 2rem;
}

.file-name-display {
  font-size: 0.85rem;
  color: #6c757d;
}
</style>